<template>
    <div v-if="dataForm.step == '02'" class="certificate-two-step">
        <ab-title title="维护企业信息">
            <div class="el-message-box__content">
                <el-form :model="companyData" ref="basicsDataForm" label-position="top" class="companyData" :rules="companyRules" style="margin: 20px 0">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="企业名称"  prop="enterpriseName">
                                <!-- <el-input size="mini"  maxLength='50' v-model="companyData.enterpriseName" placeholder="请输入"></el-input> -->
                                <ab-select
                                    url="/crm/clientRegisterStep/listByName"
                                    inputKey="keyword"
                                    isNotClear
                                    descKey="Name"
                                    @change="handleChange"
                                    @handleSelect="changeNewName"
                                    v-model="companyData.enterpriseName"
                                    :urlData="{keyword: companyData.enterpriseName}"
                                ></ab-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="邮箱" prop="enterpriseMail" style="margin-top: 5px">
                                <el-input size="medium"  maxLength='50' @blur="changeMail" v-model="companyData.enterpriseMail" placeholder="请输入邮箱"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </ab-title>
        <div class="footer" style=" margin-left: -10px">
            <el-button @click="threeStep" type="primary" :loading="isloading">下一步</el-button>
            <el-button @click="backToStep" :loading="isloading">返回</el-button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isloading: false,
            companyData: {},
            companyRules: {
                enterpriseName: [
                    { required: true, message: '请输入企业名称', trigger: 'blur'}
                ],
                enterpriseMail: [
                    { required: true, message: '请输入邮箱地址', trigger: 'blur'},
                    { validator: (rule, value, callback) => {
                        const mailReg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+[.]){1,63}[a-z0-9]+$/
                        if (!value) {
                            return callback(new Error('邮箱不能为空'))
                        }
                        if (mailReg.test(value)) {
                            callback()
                        } else {
                            callback(new Error('请输入正确的邮箱格式'))
                        }
                    }, trigger: 'blur' }
                ]
            }
        }
    },
    props: {
        dataForm: {
            type: Object,
            defualt: {}
        }
    },
    watch: {    
        dataForm: {
            handler (obj) {
                this.companyData.enterpriseName = obj.enterpriseName
                this.companyData.enterpriseMail = obj.enterpriseMail
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        threeStep() {
            sessionStorage.setItem("firstIn", true);
            this.$refs.basicsDataForm.validate(valid => {
                if (valid) {
                    this.isloading = true
                    let data = Object.assign({}, this.dataForm, {
                        enterpriseName: this.companyData.enterpriseName,
                        enterpriseMail: this.companyData.enterpriseMail,
                        step: '03'
                    })
                    this.$parent.gotoStep(data).then(res => {
                        if (res && res.data && res.data.code == 'E0008') {
                            this.$alert(data.message, '温馨提示', {
                            confirmButtonText: '确定',
                            callback: action => {

                            }})
                        }
                    }).finally(() => {
                        setTimeout(() => {
                            this.isloading = false
                        }, 200)
                    })
                }
            })
        },
        backToStep () {
            this.isloading = true
            this.$parent.backToStep('01').then(() => {}).finally(() => {
                this.isloading = false
            })
        },
        changeNewName (val) {
            console.log(val.Name, 'sssssss');
            this.companyData.enterpriseName = val.Name
             setTimeout(() => {
                this.$refs.basicsDataForm.validateField('enterpriseName')
            }, 200)
        },
        handleChange () {
            this.$refs.basicsDataForm.validateField('enterpriseName')
        },
        changeMail () {
            this.companyData.enterpriseMail=this.companyData.enterpriseMail ? this.companyData.enterpriseMail.toLowerCase() : ''
        }
    },
}
</script>

<style lang="scss">
.certificate-two-step{
    .el-message-box__content {
        .companyData{
            .el-form-item__content{
                &>div{
                    width: 100% !important;
                }
            }
            .el-select .el-input__inner{
                height: 40px !important;
            }
        }
        padding: 0;
        width: 580px;
        position: relative;
        left: 50%;
        margin-left: -290px;
        .el-autocomplete{
            height: 40px;
        }
        .el-input{
            .el-input__inner{
                height: 40px;
            }
        }
    }
}
</style>